import React from 'react';

/**
 * Context that tracks the latest updates to resources
 * and has its value set to `{ timestamp, url }`.
 */
export default React.createContext({});
